export default `
mutation qtdProduto(
    $tagEmMaos: Boolean
    $idProposta: String
    $quantidadeIdentificadores: String
    $tipoProduto: String
    $captchaResponse: String
  ) {
    qtdProdutoFCG(
      payload: {
        id: $idProposta
        captchaResponse: $captchaResponse
        pedido: {
          produtos: [
            {
              tagEmMaos: $tagEmMaos
              tipoProduto: $tipoProduto
              quantidadeIdentificadores: $quantidadeIdentificadores
            }
          ]
        }
      }
    ) {
      dados {
        id
        situacaoProposta
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
